export default __webpack_public_path__ + "static/media/offer.cd84b46c.png";